<style scoped lang="less">
  .wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    justify-content: flex-end;

    .block {
      width: 100%;
      height: 85vh;
      border-radius: 8px 8px 0 0;
      background: rgba(255, 255, 255, 1);
      display: flex;
      flex-flow: column;

      .close {
        text-align: right;
        flex-shrink: 0;

        .closeIcon {
          margin-right: 10px;
        }
      }

      .iframe {
        width: 100%;
        height: 100%;
        padding: 0 12px;
      }
    }
  }

  .confirm-btn-x {
    flex-shrink: 0;
    padding: 12px;
    border-top: 1px solid #eee;
  }

  .scroll-tip {
    font-size: 16px;
    text-align: center;
    color: #999;
  }
</style>

<template>
  <van-overlay :show="visible" z-index="999">
    <div class="wrapper" @click.stop>
      <div class="block">
        <div class="close">
          <van-icon class="closeIcon" name="cross" color="#999999" size="24px" @click="close" />
        </div>
        <div class="iframe">
          <iframe
            :src="`${url}?t=${Date.now()}`"
            width="100%"
            height="100%"
            frameborder="no"
            border="0"
            marginwidth="0"
            marginheight="0"
            scrolling="auto"
            allowtransparency="true"
          />
        </div>
        <van-row v-if="confirmBtn" class="confirm-btn-x" :gutter="[10, 10]">
          <van-col class="scroll-tip" span="24">请仔细阅读协议</van-col>
          <van-col span="12">
            <van-button type="default" block round @click="close">取消</van-button>
          </van-col>
          <van-col span="12">
            <van-button
              type="primary"
              block
              round
              color="#186EF9"
              :disabled="confirmDisabled"
              @click="confirm"
            >
              {{ confirmDisabled ? `${curCountDown} 秒后同意协议` : '同意协议' }}
            </van-button>
          </van-col>
        </van-row>
      </div>
    </div>
  </van-overlay>
</template>

<script setup lang="ts">
  import { useIntervalFn } from '@vueuse/core';

  const props = withDefaults(
    defineProps<{
      url?: string;
      confirmBtn?: boolean; // 是否展示确认按钮
      countdown?: number; // 倒计时 0 表示不使用倒计时
    }>(),
    {
      url: '',
      countdown: 5,
    }
  );
  const emits = defineEmits<{ (e: 'confirm'): void }>();

  const visible = defineModel('visible', { type: Boolean, default: false });
  const close = () => (visible.value = false);

  const confirmDisabled = ref(props.confirmBtn && props.countdown > 0);
  const curCountDown = ref(props.countdown);
  const { pause, resume } = useIntervalFn(
    () => {
      if (curCountDown.value > 1) {
        curCountDown.value--;
      } else {
        pause();
        confirmDisabled.value = false;
      }
    },
    1000,
    { immediate: false }
  );
  watch(
    visible,
    async (newVal) => {
      if (!props.confirmBtn) return;
      if (newVal) {
        await nextTick();
        curCountDown.value = props.countdown;
        confirmDisabled.value = props.confirmBtn && props.countdown > 0;
        resume();
      } else {
        pause();
      }
    },
    { immediate: true }
  );

  const confirm = () => emits('confirm');
</script>
